import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { createContext, useContext, useMemo } from 'react';
import { getPropFilter } from 'utils/ui';
import { jsx as _jsx } from "react/jsx-runtime";
var TableContext = /*#__PURE__*/createContext(null);
export var TABLE_CONTEXT_PROP_NAMES = ['mobileViewBreakpoint', 'stickyHeaderOffset', 'rowMinHeight', 'shadedHeader', 'pl', 'pr'];
export var tableContextPropFilter = getPropFilter(TABLE_CONTEXT_PROP_NAMES);
function TableContextProvider(_ref) {
  var children = _ref.children,
    mobileViewBreakpoint = _ref.mobileViewBreakpoint,
    stickyHeaderOffset = _ref.stickyHeaderOffset,
    rowMinHeight = _ref.rowMinHeight,
    shadedHeader = _ref.shadedHeader,
    pl = _ref.pl,
    pr = _ref.pr;
  var contextValue = useMemo(function () {
    return {
      mobileViewBreakpoint: mobileViewBreakpoint,
      stickyHeaderOffset: stickyHeaderOffset,
      rowMinHeight: rowMinHeight,
      shadedHeader: shadedHeader,
      pl: pl,
      pr: pr
    };
  }, [mobileViewBreakpoint, stickyHeaderOffset, rowMinHeight, shadedHeader, pl, pr]);
  return /*#__PURE__*/_jsx(TableContext.Provider, {
    value: contextValue,
    children: children
  });
}
function useTableContext() {
  var context = useContext(TableContext);
  if (context === null) {
    throw Error('useTableContext must be used inside of a TableContextProvider component');
  }
  return context;
}
function withTableContext(Component) {
  var WrappedComponent = function WrappedComponent(props) {
    var contextProps = useTableContext();
    return /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread({}, props), contextProps));
  };
  WrappedComponent.displayName = "".concat(Component.displayName || Component.name, "WithTableContext");
  return WrappedComponent;
}
export { TableContextProvider, useTableContext, withTableContext };